<script lang="ts" setup>
import ErrorAlert from "../components/alerts/ErrorAlert.vue";
import { useUserStore } from "../store/index";

//initialize store
const userStore = useUserStore();
</script>

<template>
  <ErrorAlert
    v-if="userStore.error.value == true"
    :showError="userStore.error.value == true"
    @closeError="userStore.error.value = false"
  >
    {{ userStore.error.message }}
  </ErrorAlert>
</template>
